import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { registerLicense } from '@syncfusion/ej2-base';
import { AuthProvider } from './context/AuthContext';
import { SyncProvider } from './context/SyncContext';
import { AccountProvider } from './context/AccountContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import GlobalSyncBar from './components/GlobalSyncBar';
import LoginPage from './pages/LoginPage';
import SsoCallback from './pages/SsoCallback';
import InboxPage from './pages/InboxPage';
import ComposePage from './pages/ComposePage';
import CalendarPage from './pages/CalendarPage';
import ContactsPage from './pages/ContactsPage';
import SettingsPage from './pages/SettingsPage';
import AgentCorePage from './pages/AgentCorePage';
import './App.css';

// Register Syncfusion license
registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH1fd3VcQ2VeVUR/XUdWYEs=');

function App() {
  return (
    <AuthProvider>
      <SyncProvider>
        <AccountProvider>
        <Router>
          {/* Global sync progress bar - visible on ALL pages */}
          <GlobalSyncBar />
          
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/sso-callback" element={<SsoCallback />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/inbox" replace />} />
              <Route path="inbox" element={<InboxPage />} />
              <Route path="inbox/:folderId" element={<InboxPage />} />
              <Route path="message/:messageId" element={<InboxPage />} />
              <Route path="compose" element={<ComposePage />} />
              <Route path="reply/:messageId" element={<ComposePage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="contacts" element={<ContactsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="agentcore" element={<AgentCorePage />} />
            </Route>
          </Routes>
        </Router>
        </AccountProvider>
      </SyncProvider>
    </AuthProvider>
  );
}

export default App;
